import { FC } from 'react';
import './ProfilePage.scss';
import { Card, CardHeader, Typography } from '@mui/material';
import UserProfile from 'components/Users/Profile';
import { t } from 'i18next';

const ProfilePage: FC = (): JSX.Element => {
  return (
    <div className="user-profile">
      <Card className="profile-card">
        <CardHeader
          sx={{
            padding: '25px',
          }}
          title={
            <Typography fontSize={30} fontWeight={600}>
              {t('User profile')}
            </Typography>
          }
        />
        <UserProfile />
      </Card>
    </div>
  );
};

export default ProfilePage;
